<template>
  <div>
    <div style="width: 100%;height: 32px;"></div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
      <el-form-item label="基地名称：" prop="baseName">
        <el-input style="width: 400px;" v-model="ruleForm.baseName" placeholder="请输入基地名称"></el-input>
      </el-form-item>
      <el-form-item label="基地图片：" prop="baseImg">
        <upload-img :fileList="baseImgList" :imgWhich="1" warmTxt="建议尺寸：96*96px" @imgUrlBtn="imgUrlBtn"></upload-img>
      </el-form-item>
      <el-form-item label="基地电话：" prop="basePhone">
        <el-input style="width: 400px;" v-model="ruleForm.basePhone" placeholder="请输入基地电话"></el-input>
      </el-form-item>
      <el-form-item label="基地介绍：" prop="baseText">
        <editor :value="ruleForm.baseText" :height="350" v-model="ruleForm.baseText"></editor>
      </el-form-item>
      <el-form-item label="是否开启：" prop="status">
        <el-switch
          v-model="ruleForm.status"
          active-color="#1890FF"
          inactive-color="#CCCCCC">
        </el-switch>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="medium" @click="saveBtn">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getSeleniumJourneyBaseDetail, updateSeleniumJourneyBaseInfo } from '@/api/journeySetting'
export default {
  name: 'ShopInfo',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:sessionStorage.getItem('token'),
      baseImgList:[],
      ruleForm: {
        baseName:'',
        baseImg:'',
        basePhone:'',
        baseText:'',
        status: false
      },
      rules: {
        baseName: [
          { required: true, message: '请输入基地名称', trigger: 'blur' }
        ],
        baseImg: [
          { required: true, message: '请上传基地图片', trigger: 'blur' }
        ],
        basePhone: [
          { required: true, message: '请输入基地电话', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    var that = this;
    getSeleniumJourneyBaseDetail({}).then((res) => {
     if (res.errorCode === '0000') {
        let data = res.data
        that.ruleForm.baseName = data.baseName
        let status = false
        if (data.status === 1) {
          status = true
        }
        that.ruleForm.status = status
        that.ruleForm.basePhone = data.basePhone
        that.ruleForm.baseImg = data.baseImg
        that.baseImgList.push({url: data.baseImg})
        that.ruleForm.baseText = data.baseText
     }
   })
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    /* 上传图片操作值的变动 */
    imgUrlBtn(backData){
      if(backData.imgWhich == 1){
        this.ruleForm.baseImg = backData.imgUrl;
      }
    },
    // 保存操作
    saveBtn () {
      let that = this
      let baseName = that.ruleForm.baseName
      let baseImg = that.ruleForm.baseImg
      let basePhone = that.ruleForm.basePhone
      let baseText = that.ruleForm.baseText
      let status = that.ruleForm.status ? 1 : 0
      if (baseName === '') {
        this.$message.error('请输入基地名称')
        return false
      }
      if (baseImg === '') {
        this.$message.error('请上传基地图片')
        return false
      }
      if (basePhone === '') {
        this.$message.error('请输入基地电话')
        return false
      }
      let passData = {
        baseName: baseName, baseImg: baseImg, basePhone:basePhone,baseText:baseText, status: status
      }
      updateSeleniumJourneyBaseInfo(passData).then((res) => {
        that.backDataFun(res)
      });
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {}
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/setting/components/JourneySystem.vue